export default __webpack_public_path__ + "static/media/blueedit.b8e55416.svg";